<template>
  <div class="yunxiao teacher clue all-clue">
    <search-filter-new
      :items="searchItems"
      :campus="params.campusList"
      placeholder="输入姓名/手机号后四位"
      :more="moreOperations"
      @onSearch="params.name = $event"
      @onCampus="chooseCampus"
      @onMore="onSelectOperation"
      @onAdd="$router.push('/baseStudentInput')"
    >
    </search-filter-new>
 
    <search-filter-new @change="filterChange">
      <filter-item kind="yq-排序"  :value="this.params.orderByType" :intention="true"></filter-item>
      <filter-item kind="yq-跟进人"  :value="this.params.hasFollowTeacher"></filter-item>
      <sideFilterItem  :hasFilter="hasFilter" @clickFilter="openFilter" />
    </search-filter-new>
    <div class="list-number-line" v-if="list.length">
      <div class="add-area__info">学员数量：{{ totalCount }}</div>
    </div>
    <vx-list
      class="clue-item-wrapper"
      enable
      :api="api"
      :params="queryParams"
      @load="onLoad"
      @loading="loading=true"
      ref="listScroller"
      v-if="customLoaded"
    >
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="没有找到学员"
        v-if="list.length === 0 && !loading"
        image-size="128"
        style="padding-top: 50px"
      >
      </van-empty>
      <clue-item
        v-for="item of list" 
        :infos="item" 
        :isClueStudent="true"
        :isShowRecentCommunicate="true"
        @clickItem="clickItemHandler(item)"
        :key="item.id"/>
    </vx-list>

    <!-- 导出沟通记录的时间选择弹窗 -->
    <van-dialog 
      getContainer="body"
      v-model="showToExportConfirm" 
      title="请选择导出内容" 
      class="clueStudents-to-communicate-dialog"
      :beforeClose="beforeClose"
      confirm-button-text="确认导出"
      show-cancel-button>
      <van-radio-group v-model="exportFlag">
        <van-radio :name="1" icon-size="14px" >导出学员信息</van-radio>
        <van-radio :name="2" icon-size="14px">导出学员沟通记录</van-radio>
      </van-radio-group>
      <template v-if="exportFlag==2">
        <div class="title">请选择需要导出的沟通记录的沟通时间：</div>
        <div class="date-box" 
          :class="{'empty': (!exportParams.startExportCommunicateTime && !exportParams.endExportCommunicateTime) }" 
          @click="chooseCalendar">
          <template v-if="exportParams.startExportCommunicateTime || exportParams.endExportCommunicateTime">
            {{ exportParams.startExportCommunicateTime | formatDatetime('yyyy-MM-dd') }}~{{
              exportParams.endExportCommunicateTime | formatDatetime('yyyy-MM-dd')
            }}
          </template>
          <template v-else>请选择时间区间</template>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import FilterItem from '@x3/vue/comp/filter-item.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import clueItem from "./children/clue-item.vue";
import { openClueFilter } from "./clue-filter/index.js";

export default {
  name: "intentionStudents",
  components: {
    SearchFilterNew,
    clueItem,
    FilterItem,
    sideFilterItem
  },
  data () {
    return {
      pageTitle: "意向学员",
      params: {
        name: "",
        // 校区ID集合
        campusIds: [],
        campusList: [],
        comeFroms: [],
        comeFromsList: [],
        followTeacherIds: [],
        followTeacherList: [],
        intentionClueStatusList: [],
        recoveryTeacherIds: [],
        status: [0],
        startNextTime: "",
        endNextTime: "",
        startCreateTime: '',
        hasFollowTeacher: '',
        endCreateTime: '',   
        orgTag: 1,
        startAge: '',
        endAge: '',
        orderByType: '',
        followTeacherIdsMap: { //学员跟进人(筛选条件) 1教务老师 2销售老师	
          1: [],
          2: [],
        },
        introducerIds: [],
        introducerList: [],
        startLastCommunicateTime: '', //最近沟通日期
        endLastCommunicateTime: '', //最近沟通日期
        nonFollowUpDays: '', //未跟进天数
        customFieldValueQueryDtoList: [],
        // 公立学校
        customSchool: '',
        // 公立年级
        customGradeIds: [],
        customGradeList: [],
        // 创建人id集合
        createTeacherIds: [],
        createTeacherList: [],
      },
      
      list: [],
      customFieldList: [],
      api: this.$api.listForIntentionManage,
      totalCount: 0,
      loading: true,
      customLoaded: false,
      exportParams: { //导出沟通记录时间范围
        startExportCommunicateTime: '',
        endExportCommunicateTime: ''
      },
      showToExportConfirm: false,
      exportFlag: 1 // 导出的类型：1:仅导出意向信息2：导出意向和沟通记录
    }
  },
  computed: {
    // 当前是否有筛选
    hasFilter: function () {
      let lens = [ 
        this.params.comeFroms.length,        
        (this.params.hasFollowTeacher + '').length,
        this.params.followTeacherIdsMap[1].length,
        this.params.followTeacherIdsMap[2].length,
        this.params.status.length,
        this.params.introducerIds.length,
        this.params.startNextTime.length,
        this.params.endNextTime.length,
        this.params.startCreateTime.length,
        this.params.endCreateTime.length,
        this.params.createTeacherIds.length,
        this.params.recoveryTeacherIds.length,       
        (this.params.startAge + '').length,       
        (this.params.endAge + '').length,
        this.params.startLastCommunicateTime.length,
        this.params.endLastCommunicateTime.length,
        (this.params.nonFollowUpDays+ '').length,
        this.params.customSchool.length,
        this.params.customGradeIds.length,
        Number(this.params.customFieldValueQueryDtoList.map(item=>{
          if (item.fieldDataType == 1) {
            return Number(item.textValue !== '')
          }
          if (item.fieldDataType == 2) {
            return Number(item.fromNumberValue !== '' || item.toNumberValue !== '' )
          }
          if (item.fieldDataType == 3) {
            return Number(item.fromDateValue !== '' || item.toDateValue !== '' )
          }
          if (item.fieldDataType == 4) {
            return item.selectValueList.length
          }
        }).some(it=>it>0)),
      ]
      let len = lens.reduce((cur, pre)=> (cur += pre));
      if (len > 0) {
        return true;
      } else {
        return false;
      }
    },
    queryParams () {
      let params = {...this.params}
      delete params.campusList;
      delete params.createTeacherList;
      delete params.followTeacherList;
      delete params.abandonTeacherList;
      delete params.comeFromsList;
      params.hasFollowTeacher = params.distributeStatus;
      delete params.distributeStatus;
      params.intentionClueLevel = params.level;
      delete params.level;
      delete params.customGradeList;

      params.queryCustomGrade = params.customGradeIds.length>0;
      params.startCreateTime = params.startCreateTime && app.tool.date.formatDatetime(params.startCreateTime, 'yyyy-MM-dd');
      params.endCreateTime = params.endCreateTime && app.tool.date.formatDatetime(params.endCreateTime, 'yyyy-MM-dd');

      return params;
    },
    moreOperations() {
      let actions = [];
      if (app.permission.op('assign_student')) {
        actions.push({ icon: 'fenpei', text: '分配学员', id: 1 });
      }
      if (app.permission.op('export_intention_student')) {
        actions.push({icon: 'shujudaochu' ,text: '导出', id: 2 });
      }
      return actions;
    },
    searchItems () {
      let arr = ['campus', 'search']
      if (this.moreOperations.length){
        arr.push('more');
      }
      if (app.permission.op('add_student')) {
        arr.push('add');
      }
      return arr
    }
  },
  methods: {
    // 获取自定义字段筛选
    async getCustomFields() {
      const res = await this.$api
        .getCustomFieldList({
          classify: 'STUDENT',
          businessType: 'STUDENT_OFFICIALLY',
          containBase: 0,
        }).finally(()=> {
          setTimeout(() => {          
            this.customLoaded = true
          }, 0);
        });
        const list = res.data.filter(item=> !item.fieldCode && item.displayList.find(displayObj=>displayObj.businessType == 'STUDENT_OFFICIALLY' && displayObj.display));      
      this.customFieldList = list;
      this.params.customFieldValueQueryDtoList = list.map(item=>({
        customFieldId: item.id,
        businessType: 'STUDENT_OFFICIALLY',
        fieldDataType: item.fieldDataType,
        fromDateValue: '',
        fromNumberValue: '',
        selectValueList: [],
        textValue: '',
        toDateValue: '',
        toNumberValue:'',
      }));
      this._customFieldValueQueryDtoList = JSON.parse(JSON.stringify(this.params.customFieldValueQueryDtoList));
    },    
    filterChange(data) {
      data.distributeStatus = data.hasFollowTeacher;
      app.ls.setStorage('clue-sort', data.orderByType);
      Object.assign(this.params, data)
    },
    onLoad(list, res) {
      vant.Toast.clear();
      this.list = list || [];
      this.loading = false;
      this.totalCount = res && res.page && res.page.totalCount;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
        config: {
          enableZero: false,
          zeroName: "未分配校区",
        },
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 打开筛选
    async openFilter() {
      let res = await openClueFilter({
        params: {
          ...this.params,
          distributeStatus: this.params.hasFollowTeacher,
        },
        config:{
          hideStatus: true,
          hideFollowStatus: true,
          enableIntentionStatus: true,
          showStudentIntentionStatus: true,
          showLevelFilter: true,
          followStatusStr: '学员跟进人',          
          showCreateTeacher: true,
          showIntroducer: true,
          hideJiaowuTeacherStatus: false,
          showCommunicateTime: true, //是否展示最近沟通时间
          showNotFollowUpDays: true, //是否展示未跟进天数
          customFieldList: this.customFieldList,
        },
        defaultParams: {
          intentionClueStatusList: [],
          recoveryTeacherIds: [],
          status: [0],
          customFieldValueQueryDtoList: this._customFieldValueQueryDtoList
        }
      });

      this.showLoading();
      let params = Object.assign({}, this.params, res.params);
      this.params = {
        ...params,
        hasFollowTeacher: params.distributeStatus,
        ageFrom: params.startAge,
        ageTo: params.endAge,
      }
    },
    clickItemHandler ({id}) {
      this.$router.push(`/baseStudentDetails?id=${id}&formPage=intentionStudent`);
    },
    exportAllClues () {
      if (this.list.length === 0) {
        this.$toast.fail('没有可导出的数据');
        return;
      }
      this.showLoading();
      this.$api
        .doExport({
          exportType: 1,
          condition: {
            ...this.queryParams,            
            accessEntry: 2,
          },
          campusIds: this.queryParams.campusIds,
        })
        .then(() => {          
          this.$toast.clear();
          vant.Dialog.alert({
            title:'创建导出任务',
            message: '已创建导出任务，请登录云校电脑端（yunxiao.xiaogj.com）点击右上角“任务中心”下载导出文件。',
          });
        });
    },
    chooseCalendar() { //选择要导出的沟通记录区间
      app.x3.picker.dateRange({
        startDate: this.exportParams.startExportCommunicateTime ? new Date(this.exportParams.startExportCommunicateTime) : '',
        endDate: this.exportParams.endExportCommunicateTime ? new Date(this.exportParams.endExportCommunicateTime) : '',
        attrs: {
          allowSameDay: true,
          maxDate: new Date(),
          minDate: app.tool.date.getBasedOnToDayDate(-1, 'FullYear'),
        },
      })
      .then(res => {
        this.exportParams.startExportCommunicateTime = res.startDate;
        this.exportParams.endExportCommunicateTime = res.endDate;
      })
      .catch(() => {
        console.log('取消选择或报错了');
      });
    },
    exportAllCommunication() { //导出沟通记录
      this.showLoading();
      this.$api.doExport({
        exportType: 47,
        campusIds: this.params.campusIds,
        condition: {
          ...this.params,
          ...{
            startExportCommunicateTime: app.tool.date.formatDatetime(this.exportParams.startExportCommunicateTime, 'yyyy-MM-dd'),
            endExportCommunicateTime: app.tool.date.formatDatetime(this.exportParams.endExportCommunicateTime, 'yyyy-MM-dd'),
          }
        }
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.clear()
          vant.Dialog.alert({
            title:'创建导出任务',
            message: '已创建导出任务，请登录云校电脑端（yunxiao.xiaogj.com）点击右上角“任务中心”下载导出文件。',
          });
        }
      });
    },
    beforeClose(action, done) {
      if (action == 'confirm') {
        if (this.exportFlag == 1) {
          this.exportAllClues();
          done();
        } else {
          if (!this.exportParams.startExportCommunicateTime || !this.exportParams.endExportCommunicateTime) {
            vant.Toast('请选择需要导出的沟通记录的沟通时间');
            done(false);
            return;
          }
          this.exportAllCommunication();
          done();
        }
      } else {
        done();
      }
    },
    toChooseClueStudents () {
      this.$router.push('/assign-choose-clue-students')
    },
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.toChooseClueStudents();
          break;
        case 2:
          // 初始化导出
          this.exportFlag = 1;
          this.exportParams.startExportCommunicateTime = '';
          this.exportParams.endExportCommunicateTime = '';
          this.showToExportConfirm = true;
          break;
        default:
          break;
      }
    },
    refreshFun () {
      this.$refs['listScroller'] && this.$refs['listScroller'].refresh();
    },
    hightRefreshFun () {
      this.$refs['listScroller'] && this.$refs['listScroller'].hightReFresh();
    }
  },

  watch:{
    params () {
      this.loading = true;
    },
    exportFlag (nv,ov) {
      if (nv == 2) {
        this.exportParams.startExportCommunicateTime = '';
        this.exportParams.endExportCommunicateTime = '';
      }
    }
  },
  created () {
    this.getCustomFields();

    this.$onBus('add-clue-success', this.refreshFun);
    this.$onBus('resume-clues-success', this.hightRefreshFun);
    this.$onBus('edit-clue-success', this.hightRefreshFun);
    this.$onBus('assign-clue-success', this.hightRefreshFun);
    this.$onBus('operation-clue-success', this.hightRefreshFun);
    this.$onBus('change-clue-success', this.hightRefreshFun);
    this.$onBus('refresh-student-list', this.hightRefreshFun);
    this.$onBus('delete-clues-success', this.hightRefreshFun);    
    this.$onBus('studentInputSuccess', this.refreshFun);
    const orderType = app.ls.getStorage('clue-sort');
    this.params.orderByType =  orderType === undefined ? '' : orderType;


    // 首页待办进来
    if (this.$route.params && this.$route.params.isFromTodo) {
      if (this.$route.params.isFromTodo == '1') {
        this.params.startNextTime = this.params.endNextTime = app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd');
      } else {
        this.params.startNextTime = '2020-01-01';
        const date = new Date();
        date.setDate(date.getDate() - 1);
        this.params.endNextTime = app.tool.date.formatDatetime(date, 'yyyy-MM-dd');
      }
      this.params.hasFollowTeacher = 1;
      this.params.followTeacherIds = this.params.followTeacherIdsMap[2] = [app.teacher.user.id];
      this.params.followTeacherList = [{
        id: app.teacher.user.id,
        name: app.teacher.user.name,
      }]
    } else if (this.$route.params && this.$route.params.defineParams) {
      this.params.hasFollowTeacher = 1;
      this.params.followTeacherIds = this.params.followTeacherIdsMap[2] = this.$route.params.followTeacherIds;
      this.params.followTeacherList = this.$route.params.followTeacherList;
      this.params.status = [0, 1, 7];
    }

  },
  beforeDestroy () {}
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.clue.all-clue {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .clue-item-wrapper{
    flex: 1;
    overflow-y: auto;
  }
}
</style>
<style lang="scss">
.clueStudents-to-communicate-dialog {
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  padding: 0 calc(var(--gap) * 16);
  .van-dialog__content {
    min-height: 132px;
    margin-bottom: calc(var(--gap) * 24);
    .van-radio-group {
      .van-radio {
        margin-top: calc(var(--gap) * 12);
      }
    }
    .title {
      margin: 12px 0;
      color: var(--g8);
    }
    .date-box {
      height: calc(var(--w) * 36);
      line-height: calc(var(--w) * 36);
      text-align: center;
      border-radius: var(--radius-base);
      border: 1px solid var(--g4);
      cursor: pointer;
      &.empty {
        text-align: left;
        padding: 0 6px;
        color: var(--g4);
      }
    }
  }
}
</style>